import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "filter-path" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "row flex" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "filter-card-item" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "filter-header" }
const _hoisted_10 = { class: "header-left" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "header-right" }, null, -1)
const _hoisted_12 = { class: "filter-content" }
const _hoisted_13 = { class: "filter-footer" }
const _hoisted_14 = { class: "row flex" }
const _hoisted_15 = { class: "filter-result" }
const _hoisted_16 = { class: "left" }
const _hoisted_17 = { class: "font20 bold" }
const _hoisted_18 = { class: "txt-primary" }
const _hoisted_19 = {
  key: 0,
  class: "right filter-result-right"
}
const _hoisted_20 = { class: "fix-filter-input" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_input = _resolveComponent("c-input")!
  const _directive_outside = _resolveDirective("outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle({ textAlign: _ctx.align }),
      class: "filter-card"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.searchable)
          ? (_openBlock(), _createBlock(_component_c_input, {
              key: 0,
              value: _ctx.txtSearch,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.txtSearch) = $event)),
              placeholder: _ctx.placeholder,
              label: _ctx.label,
              schema: _ctx.updateSearch,
              onEnter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onsubmit(_ctx.isSearchEnter))),
              searchable: "",
              left: false,
              type: "text",
              className: "filter-search-input"
            }, null, 8, ["value", "placeholder", "label", "schema"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          onKeydown: [
            _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args))),
            _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
          ],
          class: _normalizeClass(_ctx.isToggle ? 'show' : 'hide')
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.body && _ctx.body.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isToggle = !_ctx.isToggle)),
                      class: "btn btn-white btn-filter",
                      style: {"padding":"var(--input-padding)"}
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.filterIcon,
                        alt: ""
                      }, null, 8, _hoisted_7),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("componentFilter")), 1),
                      _createElementVNode("img", {
                        src: _ctx.isToggle ? _ctx.filterIconCaretUp : _ctx.filterIconCaret,
                        alt: ""
                      }, null, 8, _hoisted_8)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "filter-dropdown",
                style: _normalizeStyle(`min-width: ${_ctx.width}`)
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("componentFilter")), 1),
                  _hoisted_11
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.body, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(item.class)
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), {
                        key: item,
                        label: item.label,
                        value: item.value,
                        "onUpdate:value": ($event: any) => ((item.value) = $event),
                        schema: item.schema || _ctx.schema,
                        type: item.type,
                        class: _normalizeClass(item.class),
                        options: item.options,
                        multiple: item.multiple,
                        required: item.required,
                        disabled: item.disabled,
                        searchable: item.searchable,
                        optionValue: item.optionValue,
                        optionLabel: item.optionLabel,
                        align: item.align,
                        onEnter: ($event: any) => (item.enter || _ctx.submit),
                        clear: item.clear
                      }, null, 40, ["label", "value", "onUpdate:value", "schema", "type", "class", "options", "multiple", "required", "disabled", "searchable", "optionValue", "optionLabel", "align", "onEnter", "clear"]))
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.exitLabel)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onreset && _ctx.onreset(...args))),
                        class: "btn btn-gray btn-filter"
                      }, _toDisplayString(_ctx.$t(_ctx.exitLabel)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.submitLabel)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onsubmit(true))),
                        class: "btn btn-primary btn-filter"
                      }, _toDisplayString(_ctx.$t(_ctx.submitLabel)), 1))
                    : _createCommentVNode("", true)
                ])
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _renderSlot(_ctx.$slots, "search")
            ])
          ])
        ], 34)), [
          [_directive_outside, _ctx.outsideClick]
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatNumber(_ctx.meta?.length || 0)), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.meta?.length > 1
              ? _ctx.$t("componentSearchResults")
              : _ctx.$t("componentSearchResult")), 1)
        ])
      ]),
      (_ctx.body && _ctx.body.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.body, (item) => {
              return _withDirectives((_openBlock(), _createElementBlock("span", {
                key: item.key,
                class: "ml10 flex"
              }, [
                _createElementVNode("span", _hoisted_20, [
                  _createTextVNode(_toDisplayString(item?.showLabel ? (item?.label ? _ctx.$t(item?.label) + ":" : "") : "") + " " + _toDisplayString(_ctx.formatValue(item)) + " ", 1),
                  (item.delete)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        onClick: [
                          ($event: any) => (_ctx.handleDelete(item)),
                          _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                        ],
                        onDblclick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                        class: "fa fa-times-circle bold ic-arrow-down ml5 pointer",
                        style: {"right":"40px","color":"var(--gray-dark)"}
                      }, null, 40, _hoisted_21))
                    : _createCommentVNode("", true)
                ])
              ])), [
                [_vShow, item.value]
              ])
            }), 128)),
            _createElementVNode("span", {
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onreset && _ctx.onreset(...args))),
              class: "clear-all-btn txt-detail sticky-scrollbar"
            }, _toDisplayString(_ctx.$t("componentClearAll")), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}